import {
  UPDATE_GUESTS,
  UPDATE_GUESTS_UI,
} from '~/common/fabric/EventGuests/reducers/guests/constants';
import {updateGuests, updateGuestsUI} from './reducer';

export const guestsLegacyActionMapper = (store) => (next) => (action) => {
  switch (action.type) {
    case UPDATE_GUESTS:
      return store.dispatch(updateGuests(action.payload));

    case UPDATE_GUESTS_UI:
      return store.dispatch(updateGuestsUI(action.payload));

    default:
      return next(action);
  }
};
